import * as React from "react";
import { cn } from "@/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  TextareaProps & { onChangeText: (val: string) => void }
>(({ className, onChangeText, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "placeholder:text-muted-foreground flex min-h-[80px] w-full rounded-xl border bg-white px-3 py-2 text-sm focus:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        className,
        "font-inter",
      )}
      ref={ref}
      {...props}
      onChange={(ev) => {
        onChangeText?.(ev.target.value);
      }}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
